import { BaseDto } from "../base/baseDto.model";

export class TipoPunitorioDto extends BaseDto{
    public valor:number= 0
}
